export class AddToCartRequest {
    public employeeId: string;
    public name: string;
    public department: string;
    public phoneNumber: string;
    public hasTicketApp: boolean;

    constructor(employeeId: string, name: string, department: string, phoneNumber: string, hasTicketApp: boolean) {
        this.employeeId = employeeId;
        this.name = name;
        this.department = department;
        this.phoneNumber = phoneNumber;
        this.hasTicketApp = hasTicketApp;
    }
}

export class AddDepartmentToCartRequest {
    public departmentId: string;
    public name: string;

    constructor(departmentId: string, name: string) {
        this.departmentId = departmentId;
        this.name = name;
    }
}
